var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("div", { staticClass: "message-list--item-content" }, [
      _vm.computedIcon
        ? _c(
            "div",
            { staticClass: "message-list--item-icon-container" },
            [_c("Icon", { attrs: { icon: _vm.computedIcon } })],
            1
          )
        : _vm.isRecipient && !_vm.info
        ? _c(
            "div",
            { staticClass: "message-list--item-icon-container" },
            [_c("Jon", { attrs: { white: "" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message-list--item-content-inner" },
        [
          _vm.hasTextSlot
            ? [_vm._t("text")]
            : [
                _vm.customText
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.customText) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } })
              ],
          _vm._v(" "),
          _vm.showProfileInfo
            ? _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c("Button", {
                    attrs: {
                      text: "skilldoo-Profil ansehen",
                      icon: "caret-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("clickedMoreInfos")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAppointmentInfo
            ? _c(
                "div",
                [
                  _c("AppointmentInfosLight", {
                    attrs: { data: _vm.messageExtraData }
                  }),
                  _vm._v(" "),
                  _vm.isLatestMessage && _vm.isInitiatorCustomer
                    ? _c("Button", {
                        staticClass: "mt-3",
                        attrs: { text: "Termine öffnen", icon: "caret-right" },
                        on: { click: _vm.openAppointments }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAppointmentInfoConfirmed
            ? _c(
                "div",
                [
                  _c("AppointmentInfosConfirmed", {
                    attrs: { message: _vm.message, data: _vm.messageExtraData },
                    on: {
                      editAccessLink: function($event) {
                        return _vm.$emit("editAccessLink")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCollaborationText
            ? _c("div", {
                staticClass: "mt-2",
                domProps: { innerHTML: _vm._s(_vm.collaborationText) }
              })
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.showSender
      ? _c("div", { staticClass: "message-list--item-sender" }, [
          _vm.senderName
            ? _c("span", [_vm._v(_vm._s(_vm.senderName))])
            : _vm._e(),
          _vm._v(" "),
          _vm.timeStamp
            ? _c("span", [
                _vm._v(_vm._s(_vm._f("dateTime")(_vm.timeStamp)) + " Uhr")
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }